var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpenCloseIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.508,
    height: 18.54,
    viewBox: "0 0 18.508 18.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11517",
    "data-name": "Group 11517",
    transform: "translate(-1724.301 -5473.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11516",
    "data-name": "Group 11516",
    transform: "translate(1731.942 5480.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_open_3560720_000000",
    d: "M27.429,19.9A5.43,5.43,0,0,0,19,24.424h1.051a4.379,4.379,0,1,1,1.676,3.45L25.306,24.3V26.35h1.051V23.022a.526.526,0,0,0-.525-.525H22.5v1.051h2.06l-4.337,4.347.372.372A5.43,5.43,0,1,0,27.429,19.9Z",
    transform: "translate(-19 -18.993)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "np_open_3560720_000000-2",
    "data-name": "np_open_3560720_000000",
    d: "M8.429.9A5.43,5.43,0,0,0,0,5.431H1.051a4.379,4.379,0,1,1,4.87,4.356c-1.142.129-1.743,1.148-.21,1.071A5.43,5.43,0,0,0,8.429.9Z",
    transform: "translate(0.003 10.867) rotate(-90)",
    fill: "#4a4a4a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M7.763,15.587a7.793,7.793,0,1,1,7.763-7.793,7.891,7.891,0,0,1-.076,1.09,5.007,5.007,0,0,0-6.617,2.829,1.143,1.143,0,0,0-1.07-.638,1.255,1.255,0,1,0,.745,2.264c0,.047,0,.1,0,.16a4.972,4.972,0,0,0,.416,2A7.788,7.788,0,0,1,7.763,15.587ZM7.763,2A1.2,1.2,0,0,0,6.568,3.268l.353,6.207a.842.842,0,0,0,1.682,0l.354-6.207A1.2,1.2,0,0,0,7.763,2Z",
    transform: "translate(1724.301 5473.316)",
    fill: "#4a4a4a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenCloseIssue);
export default __webpack_public_path__ + "static/media/Icon_OpenClose_Issue.882f15ba.svg";
export { ForwardRef as ReactComponent };